/**
 * Reads and writes window.localStorage directly, instead of using
 * common/util/localStorage's LocalStorage wrapper.
 *
 * That wrapper cannot be imported first from a fresh module: it sits in the
 * cycle localStorage -> util-helpers -> util-consts -> localStorage, and
 * util-consts.jsx:588 calls LocalStorage.get("lookup") at module-eval time, so
 * the cycle hands it an uninitialised module and it throws. Importing this
 * zero-import sibling instead makes the agent modules order-independent.
 *
 * Do not "restore" the wrapper here — it will pass in the browser and crash
 * every vitest file that reaches this module first.
 */

export function readStoredJson(key, fallback) {
    try {
        const raw = window.localStorage.getItem(key);

        return raw === null ? fallback : JSON.parse(raw);
    } catch (error) {
        return fallback;                              // absent, corrupt, or blocked
    }
}

export function writeStoredJson(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        // Quota exceeded or storage blocked (private mode). The sheet keeps
        // working; it just will not remember its geometry.
    }
}
